module.exports = __webpack_public_path__ + "static/media/Platformbanner@2x.f1ac63ee.png";